import React, { FC } from 'react';
import { Button } from '@components';
import {
  OnboardingStepsData, PageRoutes,
} from '@utils';
import { useNavigate } from 'react-router-dom';
import { OnboardingTextBlock } from './OnboardingTextBlock';

export const OnboardingHelper: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="onboarding-wrapper helper">
      <div className="onboarding-header helper">
        Добро пожаловать в РЕЛЭКС.Календарь!
      </div>
      <div className="onboarding-helper-row">
        <OnboardingTextBlock
          step={OnboardingStepsData.STEP_ONE.step}
          stepName={OnboardingStepsData.STEP_ONE.stepName}
          list={OnboardingStepsData.STEP_ONE.list}
        />
        <OnboardingTextBlock
          step={OnboardingStepsData.STEP_TWO.step}
          stepName={OnboardingStepsData.STEP_TWO.stepName}
          list={OnboardingStepsData.STEP_TWO.list}
        />
        <OnboardingTextBlock
          step={OnboardingStepsData.STEP_TREE.step}
          stepName={OnboardingStepsData.STEP_TREE.stepName}
          list={OnboardingStepsData.STEP_TREE.list}
        />
      </div>
      <Button
        className="onboarding-close-button calendar-button"
        onClick={() => navigate(PageRoutes.CALENDAR_PAGE)}
        title="Перейти в календарь"
      />
    </div>
  );
};
